/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MappaPastoScuola { 
    chiave?: MappaPastoScuola.ChiaveEnum;
    valore?: string;
}
export namespace MappaPastoScuola {
    export type ChiaveEnum = 'DOCENTI' | 'PERSONALE_ATA' | 'PERSONALE_TECNICO' | 'COLLABORATORI';
    export const ChiaveEnum = {
        DOCENTI: 'DOCENTI' as ChiaveEnum,
        PERSONALEATA: 'PERSONALE_ATA' as ChiaveEnum,
        PERSONALETECNICO: 'PERSONALE_TECNICO' as ChiaveEnum,
        COLLABORATORI: 'COLLABORATORI' as ChiaveEnum
    };
}